var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle2, _path20, _path21, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 294,
    viewBox: "0 0 511 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_631_2969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 511,
    height: 294
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 294,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_631_2969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_2969)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.331 287.062L239.861 176.527C233.541 172.878 223.293 172.878 216.973 176.527L84.2188 253.166C77.8983 256.815 77.8983 262.731 84.2188 266.379L275.688 376.915C282.009 380.563 292.256 380.563 298.576 376.915L431.331 300.276C437.651 296.627 437.651 290.711 431.331 287.062Z",
    fill: "url(#paint0_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.411 322.328L313.439 266.346C310.238 264.498 302.519 265.958 296.198 269.607L163.444 346.246C157.124 349.894 154.595 354.35 157.796 356.198L254.768 412.18C257.969 414.028 265.688 412.568 272.009 408.92L404.763 332.281C411.083 328.632 413.612 324.176 410.411 322.328Z",
    fill: "black",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.319 197.997C226.135 199.622 230.701 199.622 233.517 197.997C236.333 196.371 236.333 193.735 233.517 192.109C230.701 190.484 226.135 190.484 223.319 192.109C220.503 193.735 220.503 196.371 223.319 197.997Z",
    fill: "black",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.519 206.773C241.335 208.398 245.901 208.398 248.717 206.773C251.533 205.147 251.533 202.511 248.717 200.885C245.901 199.259 241.335 199.259 238.519 200.885C235.703 202.511 235.703 205.147 238.519 206.773Z",
    fill: "black",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.72 215.545C256.536 217.171 261.102 217.171 263.918 215.545C266.735 213.92 266.735 211.284 263.918 209.658C261.102 208.032 256.536 208.032 253.72 209.658C250.904 211.284 250.904 213.92 253.72 215.545Z",
    fill: "black",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.479 173.479V33.7446V173.479Z",
    fill: "#B4BBC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.479 173.479V33.7446",
    stroke: "#667085",
    strokeOpacity: 0.5,
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432.56 146.952L241.091 36.4168C234.77 32.768 224.523 32.768 218.202 36.4168L85.4482 113.056C79.1278 116.704 79.1278 122.62 85.4482 126.269L276.918 236.804C283.238 240.453 293.486 240.453 299.806 236.804L432.56 160.165C438.881 156.517 438.881 150.601 432.56 146.952Z",
    fill: "url(#paint1_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_631_2969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 83,
    width: 172,
    height: 109
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.297 165.991L169.262 99.0038C165.431 96.7926 161.935 95.2258 161.453 95.5043L151.319 101.355C150.836 101.633 153.55 103.652 157.38 105.863L273.416 172.85C277.247 175.061 280.743 176.628 281.225 176.35L291.359 170.499C291.842 170.221 289.128 168.202 285.297 165.991Z",
    fill: "url(#paint2_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M261.852 179.468L145.816 112.481C141.986 110.27 138.49 108.703 138.007 108.981L127.873 114.832C127.391 115.11 130.105 117.129 133.935 119.34L249.971 186.327C253.801 188.539 257.297 190.105 257.78 189.827L267.914 183.976C268.396 183.698 265.682 181.68 261.852 179.468Z",
    fill: "url(#paint3_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M270.232 85.75L250.741 127.747L197.491 97.003L270.232 85.75Z",
    fill: "url(#paint4_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 281.057 100)",
    fill: "url(#paint5_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_631_2969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.297 165.991L169.262 99.0038C165.431 96.7926 161.935 95.2258 161.453 95.5043L151.319 101.355C150.836 101.633 153.55 103.652 157.38 105.863L273.416 172.85C277.247 175.061 280.743 176.628 281.225 176.35L291.359 170.499C291.842 170.221 289.128 168.202 285.297 165.991Z",
    fill: "url(#paint6_linear_631_2969)",
    fillOpacity: 0.9,
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.852 179.468L145.816 112.481C141.986 110.27 138.49 108.703 138.007 108.981L127.873 114.832C127.391 115.11 130.105 117.129 133.935 119.34L249.971 186.327C253.801 188.539 257.297 190.105 257.78 189.827L267.914 183.976C268.396 183.698 265.682 181.68 261.852 179.468Z",
    fill: "url(#paint7_linear_631_2969)",
    fillOpacity: 0.9,
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.232 85.75L250.741 127.747L197.491 97.003L270.232 85.75Z",
    fill: "url(#paint8_linear_631_2969)",
    fillOpacity: 0.9,
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 281.057 100)",
    fill: "url(#paint9_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_631_2969)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 171,
    cy: 178.5,
    rx: 50,
    ry: 47.5,
    fill: "#DD9F03",
    fillOpacity: 0.9
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9062 260.075V119.968",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.867 209.126L203.867 194.424",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M438.097 153.798V294.927",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M413 199V340.129",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158 226V367.129",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M259 284L259 330",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M412.411 195.328L315.439 139.346C312.238 137.498 304.519 138.958 298.198 142.607L165.444 219.246C159.124 222.894 156.595 227.35 159.796 229.198L256.768 285.18C259.969 287.028 267.688 285.568 274.009 281.92L406.763 205.281C413.083 201.632 415.612 197.176 412.411 195.328Z",
    fill: "url(#paint10_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_631_2969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 181,
    width: 158,
    height: 84
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M331.232 183.75L311.741 225.747L258.491 195.003L331.232 183.75Z",
    fill: "url(#paint11_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 342.057 198)",
    fill: "url(#paint12_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M309.644 240.749L241.405 201.355C239.152 200.054 236.935 199.226 236.453 199.504L226.319 205.355C225.836 205.633 227.271 206.913 229.524 208.214L297.763 247.608C300.015 248.908 302.233 249.737 302.715 249.458L312.849 243.608C313.332 243.33 311.897 242.05 309.644 240.749Z",
    fill: "url(#paint13_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M286.199 254.226L217.96 214.831C215.707 213.531 213.49 212.702 213.007 212.981L202.873 218.831C202.391 219.11 203.826 220.39 206.078 221.69L274.318 261.085C276.57 262.385 278.787 263.213 279.27 262.935L289.404 257.085C289.886 256.806 288.451 255.526 286.199 254.226Z",
    fill: "url(#paint14_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_631_2969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.232 183.75L311.741 225.747L258.491 195.003L331.232 183.75Z",
    fill: "#8E8E8E",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 342.057 198)",
    fill: "url(#paint15_linear_631_2969)",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.644 240.749L241.405 201.355C239.152 200.054 236.935 199.226 236.453 199.504L226.319 205.355C225.836 205.633 227.271 206.913 229.524 208.214L297.763 247.608C300.015 248.908 302.233 249.737 302.715 249.458L312.849 243.608C313.332 243.33 311.897 242.05 309.644 240.749Z",
    fill: "#8E8E8E",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.199 254.226L217.96 214.831C215.707 213.531 213.49 212.702 213.007 212.981L202.873 218.831C202.391 219.11 203.826 220.39 206.078 221.69L274.318 261.085C276.57 262.385 278.787 263.213 279.27 262.935L289.404 257.085C289.886 256.806 288.451 255.526 286.199 254.226Z",
    fill: "#8E8E8E",
    stroke: "#1E1E1E",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_631_2969)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 394,
    cy: 208,
    rx: 92,
    ry: 77,
    fill: "#F84B2E",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_631_2969)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.5,
    cy: 224,
    rx: 62.5,
    ry: 60,
    fill: "#DD9F03",
    fillOpacity: 0.5
  })))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 294,
    fill: "url(#paint16_linear_631_2969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_631_2969",
    x: 71,
    y: 81,
    width: 200,
    height: 195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_631_2969"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_631_2969",
    x: 252,
    y: 81,
    width: 284,
    height: 254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_631_2969"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_631_2969",
    x: 103,
    y: 114,
    width: 225,
    height: 220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_631_2969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_2969",
    x1: 73.3162,
    y1: 260.406,
    x2: 287.918,
    y2: 88.7046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_2969",
    x1: 74.5457,
    y1: 120.296,
    x2: 289.148,
    y2: -51.4058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_631_2969",
    x1: 211.82,
    y1: 125.648,
    x2: 195.306,
    y2: 167.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_631_2969",
    x1: 188.375,
    y1: 139.125,
    x2: 171.86,
    y2: 180.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_631_2969",
    x1: 297.532,
    y1: 59.4047,
    x2: 303.972,
    y2: 125.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_631_2969",
    x1: 7.36967,
    y1: -12.4542,
    x2: 29.8898,
    y2: 3.58846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_631_2969",
    x1: 211.82,
    y1: 125.648,
    x2: 195.306,
    y2: 167.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_631_2969",
    x1: 188.375,
    y1: 139.125,
    x2: 171.86,
    y2: 180.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_631_2969",
    x1: 175,
    y1: 101,
    x2: 208.959,
    y2: 57.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_631_2969",
    x1: 7.36967,
    y1: -12.4542,
    x2: 29.8898,
    y2: 3.58846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_631_2969",
    x1: 154.138,
    y1: 226.252,
    x2: 413.518,
    y2: 155.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_631_2969",
    x1: 358.532,
    y1: 157.405,
    x2: 364.972,
    y2: 223.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_631_2969",
    x1: 7.36967,
    y1: -12.4542,
    x2: 29.8898,
    y2: 3.58846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_631_2969",
    x1: 265.693,
    y1: 217.451,
    x2: 253.735,
    y2: 257.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_631_2969",
    x1: 242.248,
    y1: 230.927,
    x2: 230.29,
    y2: 270.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_631_2969",
    x1: 7.36967,
    y1: -12.4542,
    x2: 29.8898,
    y2: 3.58846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#8E8E8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_631_2969",
    x1: 255.5,
    y1: 0,
    x2: 255.5,
    y2: 294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_2969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 370,
    fill: "white",
    transform: "translate(74 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/UI.df72da43cf1e67a422cd8d06eb324a72.svg";
export { ForwardRef as ReactComponent };